// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-project-project-hero----project-hero-module---container---1xo5O","content":"src-components-project-project-hero----project-hero-module---content---_9cyQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-hero/project-hero.module.css
// module id = 520
// module chunks = 168707334958949